import type { ProductCardTranslations } from "./pl";

export const en: ProductCardTranslations = {
  addToCart: "Add to cart",
  addingToCart: "Adding...",
  addedToCart: (productName: string): string =>
    `Added to cart: ${productName}.`,
  addToCartFailed: "Failed to add the product to the cart.",
  badges: {
    bestseller: "Bestseller",
    recomended: "Recommended",
    new: "New",
  },
  status: {
    temporary_unavailable: "Temporarily unavailable.",
    archive: "Archived.",
    in_set: "Available only as part of a set.",
  },
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2);
    return currency ? `${rounded} ${currency}` : rounded;
  },
  lowestPrice: (formatted: string): string =>
    `Lowest price in the last 30 days: ${formatted}`,
};
